// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { CalendarIcon, HeartIcon, HeartFilledIcon } from "./icons.jsx";
// import { get, post } from "../lib/http.js";
// import { API } from "../config/api.js";

// const currencyINR = (n) =>
//   typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—";

// export default function EventCard({
//   item,
//   showBookButton = true,
//   compact = false,
//   bodyBg = "white",
// }) {
//   const bodyBgClass = bodyBg === "yellow" ? "bg-[#fff8e1]" : "bg-white";

//   const [wishlisted, setWishlisted] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // ✅ check wishlist status from API when card mounts
//   useEffect(() => {
//     const checkWishlist = async () => {
//       try {
//         const raw = localStorage.getItem("bb_user");
//         const parsed = raw ? JSON.parse(raw) : null;
//         const userId = parsed?.id;
//         const token = parsed?.token;

//         if (!userId || !token) return;

//         // call API
//         const res = await get(`${API.wishlist.getWishlist}/${userId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const wishlistItems = res?.wishlist || res || [];

//         // ✅ check if current item.id matches any object._id in the array
//         const isWishlisted = wishlistItems?.eventIds?.some(obj => obj._id === item.id);
//         setWishlisted(isWishlisted);

//       } catch (err) {
//         console.error("Error checking wishlist:", err);
//       }
//     };
//     checkWishlist();
//   }, [item.id]);


//   // ✅ toggle wishlist with API
//   const handleWishlistClick = async () => {
//     if (loading) return;
//     setLoading(true);

//     try {
//       const raw = localStorage.getItem("bb_user");
//       const parsed = raw ? JSON.parse(raw) : null;
//       const userId = parsed?.id;
//       const token = parsed?.token;

//       if (!userId || !token) {
//         console.warn("User not logged in");
//         return;
//       }

//       if (wishlisted) {
//         // ✅ Remove from wishlist
//         await post(`${API.wishlist.removeFromWishlist}`, {
//           userId,
//           eventId: item.id,
//         }, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         setWishlisted(false);
//       } else {
//         // ✅ Add to wishlist (array me add karna hoga)
//         await post(API.wishlist.addToWishlist, {
//           userId,
//           eventIds: [item.id],
//         }, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         setWishlisted(true);
//       }
//     } catch (err) {
//       console.error("Wishlist API error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="group flex h-full flex-col overflow-hidden rounded-[22px] bg-white shadow-[0_8px_24px_rgba(0,0,0,0.08)] hover:shadow-[0_10px_28px_rgba(0,0,0,0.12)] transition">
//       {/* Image */}
//       <div className="relative">
//         <img
//           src={item.image}
//           alt={item.title}
//           className={`${compact ? "h-40" : "h-56"} w-full object-contain`}
//           style={{ objectPosition: "center", backgroundColor: "#000", width: "100%" }}
//         />

//         {/* Wishlist Button ❤️ */}
//         <button
//           onClick={handleWishlistClick}
//           disabled={loading}
//           className="absolute right-3 top-3 rounded-full bg-white/90 p-2 shadow hover:bg-white disabled:opacity-50"
//         >
//           {wishlisted ? (
//             <HeartFilledIcon className="h-5 w-5 text-red-500" />
//           ) : (
//             <HeartIcon className="h-5 w-5 text-slate-600" />
//           )}
//         </button>
//       </div>

//       {/* Body */}
//       <div
//         className={`flex flex-1 flex-col ${bodyBgClass} p-4 md:p-5 rounded-b-[22px]`}
//       >
//         <h3
//           className="truncate text-lg font-semibold text-slate-900"
//           title={item.title}
//         >
//           {item.title}
//         </h3>

//         {item.location && (
//           <p
//             className="mt-1 text-sm text-slate-600 truncate"
//             title={item.location}
//           >
//             {item.location}
//           </p>
//         )}

//         {item.date && (
//           <div className="mt-2 flex items-center gap-2 text-sm text-slate-700">
//             <CalendarIcon />
//             <span className="truncate">{item.date}</span>
//           </div>
//         )}

//         <div className="flex-1" />

//         <div className="mt-4 flex items-end justify-between">
//           <div>
//             <div className="text-xs text-slate-600">Starting from</div>
//             <div className="text-xl font-extrabold text-slate-900">
//               {item.price === 0 ? "Free Entry" : currencyINR(item.price)}
//             </div>
//           </div>

//           {showBookButton && (
//             <Link
//               to={`/events/${item.id}`}
//               className="rounded-full bg-amber-400 px-5 py-2 text-sm font-semibold text-slate-900 shadow hover:bg-amber-300"
//             >
//               Show Details
//             </Link>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


// src/components/EventCard.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarIcon, HeartIcon, HeartFilledIcon } from "./icons.jsx";
import { get, post } from "../lib/http.js";
import { API } from "../config/api.js";
import {
  fetchUserWishlistEventIds,
  patchWishlistCache,
} from "../lib/wishlistCache.js";

const currencyINR = (n) =>
  typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—";

// Fallback thumb icon (green like BookMyShow vibe)
function ThumbIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M14 9V5a3 3 0 0 0-3-3l-1 7H5a2 2 0 0 0-2 2v8a3 3 0 0 0 3 3h9.5a3 3 0 0 0 2.9-2.26l1.12-4.48A3 3 0 0 0 16.6 12H14z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function EventCard({
  item, // { id, title, image, location, date, price }
  showBookButton = true,
  compact = false,
  bodyBg = "white",
}) {
  const bodyBgClass = bodyBg === "yellow" ? "bg-[#fff8e1]" : "bg-white";
  const navigate = useNavigate();
  const eventUrl = `/events/${item.id}`;

  // ---- wishlist state ----
  const [wishlisted, setWishlisted] = useState(false);
  const [loading, setLoading] = useState(false);

  // ---- interested count ----
  const [interestCount, setInterestCount] = useState(0);
  const [interestLoading, setInterestLoading] = useState(true);

  // ✅ fetch wishlist status (shared cache — one API call per user)
  useEffect(() => {
    let alive = true;
    const checkWishlist = async () => {
      try {
        const raw = localStorage.getItem("bb_user");
        const parsed = raw ? JSON.parse(raw) : null;
        const userId = parsed?.id || parsed?._id;
        const token = parsed?.token;
        if (!userId || !token || !item?.id) return;

        const eventIds = await fetchUserWishlistEventIds(userId, token);
        if (!alive) return;
        const eventId = String(item.id);
        setWishlisted(eventIds.some((id) => id === eventId));
      } catch {
        if (alive) setWishlisted(false);
      }
    };
    checkWishlist();
    return () => {
      alive = false;
    };
  }, [item?.id]);

  // ✅ fetch "I'm interested" count
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        setInterestLoading(true);
        if (!item?.id) return;
        const res = await get(API.interest.count(item.id));
        if (!isMounted) return;
        setInterestCount(Number(res?.count ?? 0));
      } catch (e) {
        console.error("interest count error:", e);
      } finally {
        if (isMounted) setInterestLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [item?.id]);

  // ✅ toggle wishlist
  const handleWishlistClick = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const raw = localStorage.getItem("bb_user");
      const parsed = raw ? JSON.parse(raw) : null;
      const userId = parsed?.id;
      const token = parsed?.token;

      if (!userId || !token) {
        console.warn("User not logged in");
        setLoading(false);
        return;
      }

      if (wishlisted) {
        await post(
          `${API.wishlist.removeFromWishlist}`,
          { userId, eventId: item.id },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setWishlisted(false);
        patchWishlistCache(userId, item.id, false);
      } else {
        await post(
          API.wishlist.addToWishlist,
          { userId, eventIds: [item.id] },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setWishlisted(true);
        patchWishlistCache(userId, item.id, true);
      }
    } catch (err) {
      console.error("Wishlist API error:", err);
    } finally {
      setLoading(false);
    }
  };

  const openEvent = () => {
    if (showBookButton && item?.id) navigate(eventUrl);
  };

  return (
    <div
      role={showBookButton ? "button" : undefined}
      tabIndex={showBookButton ? 0 : undefined}
      onClick={openEvent}
      onKeyDown={(e) => {
        if (showBookButton && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          openEvent();
        }
      }}
      className={`group flex h-full min-w-0 max-w-full flex-col overflow-hidden rounded-2xl border border-slate-200/70 bg-white font-sans shadow-[0_6px_18px_rgba(0,0,0,0.06)] transition hover:border-amber-200/60 hover:shadow-[0_10px_26px_rgba(0,0,0,0.1)] ${showBookButton ? "cursor-pointer" : ""}`}
    >
      {/* Image */}
      <div className="relative overflow-hidden bg-slate-100">
        <img
          src={item.image || undefined}
          alt=""
          className={`${compact ? "h-36" : "h-44"} w-full object-cover`}
        />

        {/* Wishlist Button ❤️ */}
        {showBookButton && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleWishlistClick(e);
          }}
          disabled={loading}
          className="absolute right-3 top-3 z-10 rounded-full bg-white/90 p-2 shadow hover:bg-white disabled:opacity-50"
          aria-label={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
          title={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
        >
          {wishlisted ? (
            <HeartFilledIcon className="h-5 w-5 text-red-500" />
          ) : (
            <HeartIcon className="h-5 w-5 text-slate-600" />
          )}
        </button>
        )}
      </div>

      {/* Body */}
      <div className={`flex min-w-0 flex-1 flex-col ${bodyBgClass} rounded-b-2xl p-3.5 md:p-4`}>
        {/* Interested badge — RIGHT aligned, just below image */}
        <div className="mb-2 flex justify-end">
          <div
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-200/80 bg-white px-2.5 py-1 text-[12px] font-semibold text-slate-800 shadow-sm"
            title="People interested"
          >
            <ThumbIcon className="h-4 w-4 text-emerald-600" />
            {interestLoading ? "—" : `${interestCount.toLocaleString()}`}
          </div>
        </div>

        {/* Title */}
        <h3
          className="line-clamp-2 text-base font-bold leading-snug tracking-tight text-slate-900"
          title={item.title}
        >
          {item.title}
        </h3>

        {/* Location */}
        {item.location && (
          <p className="mt-1.5 min-w-0 break-words truncate text-[13px] font-medium text-slate-600" title={item.location}>
            {item.location}
          </p>
        )}

        {/* Date */}
        {item.date && (
          <div className="mt-2 flex items-center gap-2 text-[13px] font-medium text-slate-800">
            <CalendarIcon />
            <span className="min-w-0 flex-1 line-clamp-2 leading-snug">{item.date}</span>
          </div>
        )}

        <div className="flex-1" />

        {/* Price + CTA */}
        <div className="mt-4 flex items-end justify-between gap-2">
          {showBookButton && (
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wide text-slate-500">
              Starting from
            </div>
            <div className="text-xl font-extrabold leading-none text-amber-700">
              {item.price === 0 ? "Free" : currencyINR(item.price)}
            </div>
          </div>
          )}
          {showBookButton && (
            <span className="shrink-0 rounded-xl bg-amber-400 px-3.5 py-2 text-xs font-bold text-slate-900 shadow-sm sm:text-sm">
              Show details
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
